import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  REPORT_CUSTOMER_REPORT_FAILURE,
  REPORT_CUSTOMER_REPORT_REQUEST,
  REPORT_CUSTOMER_REPORT_SEARCH_FAILURE,
  REPORT_CUSTOMER_REPORT_SEARCH_REQUEST,
  REPORT_CUSTOMER_REPORT_SEARCH_SUCCESS,
  REPORT_CUSTOMER_REPORT_SUCCESS,
} from "./CustomerReportTypes";

const initialState = {
  viewAllCustomerReports: { ...defaultStatus },
  searchCustomerReports: { ...defaultStatus },
};

export default function reportReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    //Customer Report
    case REPORT_CUSTOMER_REPORT_REQUEST:
      return {
        ...state,
        viewAllCustomerReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_CUSTOMER_REPORT_SUCCESS:
      return {
        ...state,
        viewAllCustomerReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_CUSTOMER_REPORT_FAILURE:
      return {
        ...state,
        viewAllCustomerReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Customer Report Search
    case REPORT_CUSTOMER_REPORT_SEARCH_REQUEST:
      return {
        ...state,
        searchCustomerReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_CUSTOMER_REPORT_SEARCH_SUCCESS:
      return {
        ...state,
        searchCustomerReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_CUSTOMER_REPORT_SEARCH_FAILURE:
      return {
        ...state,
        searchCustomerReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };
    default:
      return state;
  }
}
